import React from 'react'
import { getAnalytics, logEvent } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import { projectFirestore } from '../firebase/config';


 const analytics = getAnalytics();

 const FBCAnalytics = ({title, message}) =>{

  logEvent(analytics,title, {info: message})

 }

export default FBCAnalytics;

